import React from 'react';
import { Col, Form } from "react-bootstrap";
import { Select } from './Inputs';

export const FormCell = ({ children }) => <Col lg={6} md={6} sm={12} xs={12}>{children}</Col>;

Form.Select = Select;
Form.Cell = FormCell;

export default Form;